import React from 'react';

const File = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
        <path d="M495.658 202.79H16.342c-9.628 0-17.18 8.297-16.267 17.892l18.754 196.643c.801 8.386 7.844 14.789 16.267 14.789h441.806c8.423 0 15.467-6.403 16.267-14.788l18.755-196.644c.913-9.586-6.628-17.892-16.266-17.892zM464.932 116.758H233.457v-20.53c0-9.024-7.316-16.34-16.34-16.34H47.164c-9.024 0-16.34 7.316-16.34 16.34v73.88h450.448v-37.01c0-9.024-7.316-16.34-16.34-16.34z" />
      </svg>
    )
}

export default File;
